// seo_utilities.js

function getQueryParams(queryString) {
  var params = {};
  if (!queryString) return params;
  var pairs = queryString.replace(/^\?/, '').split('&');
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split('=');
    if (pair[0]) {
      params[decodeURIComponent(pair[0])] = typeof pair[1] !== 'undefined' ? decodeURIComponent(pair[1]) : '';
    }
  }
  return params;
}

function setNoindexIfFilteredOrOrdered() {
  var params = getQueryParams(window.location.search);
  var foundInParams = Object.keys(params).some(function(key) {
    return key.indexOf('filter.v') !== -1 || key.indexOf('sort_by') !== -1;
  });
  if (foundInParams) {
    var metas = document.querySelectorAll('meta');
    var robotsMeta = null;
    for (var i = 0; i < metas.length; i++) {
      if (metas[i].getAttribute('name') === 'robots') {
        robotsMeta = metas[i];
        break;
      }
    }
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute('content', 'noindex, follow, noarchive');
  }
}

// Ejecuta al cargar
setNoindexIfFilteredOrOrdered();

// Escucha clics en los botones de aplicar filtros y ordenar
function attachListeners() {
  var filterDrawer = document.querySelector('#facets-drawer button');
  if (filterDrawer) {
    filterDrawer.addEventListener('click', function() {
    // Puede haber un retardo en la actualización de la URL, así que ejecutamos después de un pequeño timeout
    setTimeout(setNoindexIfFilteredOrOrdered, 200);
    });
  }

  var orderButtons = document.querySelector('#sort-by-popover');
  if (orderButtons) {
    orderButtons.addEventListener('facet:update', function() {
      setTimeout(setNoindexIfFilteredOrOrdered, 200);
    });
  }
}

// Espera a que el DOM esté listo antes de añadir los listeners
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', attachListeners);
} else {
  attachListeners();
}